var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcActiveSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "q9s8bdtxsa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FFF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m239.479 18.924-5.058-5.127a9.055 9.055 0 0 0 1.358-4.786c0-4.977-3.98-9.011-8.89-9.011S218 4.034 218 9.011c0 4.977 3.98 9.011 8.89 9.011a8.766 8.766 0 0 0 5.077-1.615l4.998 5.066a1.761 1.761 0 0 0 2.515 0 1.82 1.82 0 0 0-.001-2.549zm-12.59-3.821c-3.318 0-6.008-2.727-6.008-6.091 0-3.365 2.69-6.092 6.008-6.092 3.32 0 6.01 2.727 6.01 6.092 0 3.364-2.69 6.09-6.01 6.09z",
    transform: "translate(-218)",
    fill: "url(#q9s8bdtxsa)",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActiveSearch);
export default __webpack_public_path__ + "static/media/ic_active_search.f90cfe620c81a691768fe98118643cb1.svg";
export { ForwardRef as ReactComponent };